"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyOption1ToJSON = exports.SurveyOption1FromJSONTyped = exports.SurveyOption1FromJSON = exports.instanceOfSurveyOption1 = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the SurveyOption1 interface.
 */
function instanceOfSurveyOption1(value) {
    var isInstance = true;
    isInstance = isInstance && "optionText" in value;
    return isInstance;
}
exports.instanceOfSurveyOption1 = instanceOfSurveyOption1;
function SurveyOption1FromJSON(json) {
    return SurveyOption1FromJSONTyped(json, false);
}
exports.SurveyOption1FromJSON = SurveyOption1FromJSON;
function SurveyOption1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'optionIndex': !(0, runtime_1.exists)(json, 'option_index') ? undefined : json['option_index'],
        'optionText': json['option_text'],
        'isExclusive': !(0, runtime_1.exists)(json, 'is_exclusive') ? undefined : json['is_exclusive'],
        'isPositive': !(0, runtime_1.exists)(json, 'is_positive') ? undefined : json['is_positive'],
        'isLast': !(0, runtime_1.exists)(json, 'is_last') ? undefined : json['is_last'],
        'optionKey': !(0, runtime_1.exists)(json, 'option_key') ? undefined : json['option_key'],
        'defaultText': !(0, runtime_1.exists)(json, 'default_text') ? undefined : json['default_text'],
    };
}
exports.SurveyOption1FromJSONTyped = SurveyOption1FromJSONTyped;
function SurveyOption1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'option_index': value.optionIndex,
        'option_text': value.optionText,
        'is_exclusive': value.isExclusive,
        'is_positive': value.isPositive,
        'is_last': value.isLast,
        'option_key': value.optionKey,
        'default_text': value.defaultText,
    };
}
exports.SurveyOption1ToJSON = SurveyOption1ToJSON;
